import React from "react";
import PropTypes from "prop-types";
import styles from "./ViewErrorInfoModal.module.css";
import ModalActionBar from "shared/ModalActionBar";
import { Modal } from "shared/Modal";

/**
 *
 * Interactive component. Modal used for viewing details about sync errors.
 *
 */

export function ViewErrorInfoModal({ isOpen, onClose, errors }) {
  return (
    <div className={styles.container}>
      <Modal
        isOpen={isOpen}
        title="VIEW SYNC ERRORS"
        closeBtn="none"
        className={styles.modal}
        onClose={onClose}
      >
        <div className={styles.infoContainer}>
          <div className={styles.infoDiv}>
            <p className={styles.label}>IBO Name:</p>
            <p className={styles.description}>{errors.name}</p>
          </div>
          <div className={styles.infoDiv}>
            <p className={styles.label}>IBO #:</p>
            <p className={styles.description}>{errors.iboNum}</p>
          </div>
          <div className={styles.infoDiv}>
            <p className={styles.label}>Sync Date:</p>
            <p className={styles.description}>
              {errors.date + " " + errors.time}
            </p>
          </div>
        </div>

        <div className={styles.errorContainer}>
          <div className={styles.errors}>{errors.syncError}</div>
        </div>
        <div className={styles.btnContainer}>
          <ModalActionBar
            children={
              <button
                type="button"
                className={styles.closeBtn}
                onClick={onClose}
              >
                Close
              </button>
            }
          />
        </div>
      </Modal>
    </div>
  );
}

ViewErrorInfoModal.propTypes = {
  /**
   * Boolean to determine if modal is open
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * 	Object with the errors info
   */
  errors: PropTypes.shape({
    name: PropTypes.string,
    iboNum: PropTypes.string,
    syncError: PropTypes.string,
    date: PropTypes.string,
    time: PropTypes.string,
    status: PropTypes.bool,
  }),
};
